import { render, staticRenderFns } from "./Packliste.vue?vue&type=template&id=087acebc&scoped=true&"
import script from "./Packliste.vue?vue&type=script&lang=js&"
export * from "./Packliste.vue?vue&type=script&lang=js&"
import style0 from "./Packliste.vue?vue&type=style&index=0&id=087acebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087acebc",
  null
  
)

export default component.exports